import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekes.png";
import { useNavigate } from "react-router-dom";

const AttendanceGym1MemberPerpanjangan=(props)=>{

    const [nama,setNama]=useState("");
    const [alamat,setAlamat]=useState("");
    const [nomorHandphone,setNomorHandphone]=useState("");
    const [status,setStatus]=useState("");
    const [waktuMember,setWaktuMember]=useState("Pilih");
    const [expiredMember,setExpiredMember]=useState("");
    const [pembayaran,setPembayaran]=useState("Pilih");
    const [gender,setGender]=useState("Pilih");
    const [member,setMember]=useState(true);
    const [keteranganKirim,setKeteranganKirim]=useState("");
    const [trainer,setTrainer]=useState(false);
    const [lsStartMember,setLsStartMember]=useState("");
    const [lsExpiredMember,setLsExpiredMember]=useState("");
    const [rfid,setRfid]=useState("");

    const url = props.url;
    

const navigate =useNavigate("");
    //function klik logo gym
    const KlikLogoGym=()=>{
        navigate("/gym1/attendance");
    }

// helper: format YYYY-MM-DD (lokal)
function formatLocalYYYYMMDD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// helper: tambah hari
function tambahHari(startDate, jumlahHari) {
  const d = new Date(startDate);
  d.setDate(d.getDate() + jumlahHari);
  return d;
}

// function ubah waktu member
const WaktuMember = (value) => {
  setWaktuMember(value);

  const now = new Date();
  let daysToAdd = 0;
  if (value === "Member 1 Bulan") daysToAdd = 30;
  else if (value === "Member 3 Bulan") daysToAdd = 90;
  else if (value === "Member 6 Bulan") daysToAdd = 180;
  else if (value === "Member 12 Bulan") daysToAdd = 365;
  else {
    setExpiredMember("");
    return;
  }

  const expiredDate = tambahHari(now, daysToAdd);


  setExpiredMember(formatLocalYYYYMMDD(expiredDate));
};
// function pilih status
const Status=(value)=>{
    setStatus(value);
    if(value === "Member Umum" || value === "Member Pelajar"){
        setMember(true);
        setTrainer(false);
    }else if(value === "Trainer"){
setMember(false);
setTrainer(true);
    }else{
        setMember(false);
        setTrainer(false);
    }
}
// fucntion clear
const Clear=()=>{
    setNama("");
    setAlamat("");
    setNomorHandphone("");
    setStatus("Pilih");
    setWaktuMember("Pilih");
    setExpiredMember("");
    setPembayaran("Pilih");
    setGender("Pilih");

}
// function klik kirim
const KlikKirim=()=>{

    

    if(waktuMember==="Pilih"||pembayaran==="Pilih"){
        setKeteranganKirim("Data tidak lengkap");
    }else{
        fetch(url + "/?op=inputGymPerpanjangan", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "rfid="+rfid+
      "&nama="+nama+
      "&alamat="+alamat+
      "&nomor="+nomorHandphone+
      "&status="+status+
      "&waktu="+waktuMember+
      "&pembayaran="+pembayaran+
      "&waktuExpired="+expiredMember
      
    })
    .then((response) => response.json())
    .then((json)=>{
    
        if(json==="berhasil"){
            Clear();
            setKeteranganKirim("Data berhasil terkirim");
            setTimeout(() => {
    setKeteranganKirim("");
    navigate("/gym1/attendance");
    localStorage.removeItem("data");
  }, 1000);
        }
    })
}
 
}
//use effect
useEffect(()=>{
const data = localStorage.getItem("data");
setNama(JSON.parse(data)[2]);
setAlamat(JSON.parse(data)[3]);
setNomorHandphone(JSON.parse(data)[4]);
setLsStartMember(JSON.parse(data)[5]);
setLsExpiredMember(JSON.parse(data)[6]);
setStatus(JSON.parse(data)[7]);
setRfid(JSON.parse(data)[1]);
},[])
// use effect cek session
   useEffect(()=>{
       fetch(url + "/?op=cekSession", {
           credentials: "include", 
         })
         .then((response)=>response.json())
         .then((json)=>{
          
         if (json === "kosong") {
               navigate("/", { replace: true });
             }else if(json ==="gym2"){
   navigate("/gym2", { replace: true });
             }else if(json ==="owner"){
   navigate("/owner", { replace: true });
             }
         })
       },[])
return(
    <div className={style.containerAll}>
<div className={style.containerJudul}>
    Extend Member
    <div style={{cursor:"pointer"}} onClick={()=>KlikLogoGym()}>
        <img src={LogoGym}/>
    </div>
    </div>
    <div className={style.containerIsi}>
<div className={style.divForm}>
<div className={style.judulForm}>
Perpanjang Member
</div>
<div className={style.divPetunjukWaktuMember}>
<div className={style.divStart}>
<div>
Start
</div>
<div>
{lsStartMember}
</div>
</div>
<div className={style.divPenghubung}>
    <div>

    </div>
</div>
<div className={style.divFinish}>
<div>
Finish
</div>
<div>
{lsExpiredMember}
</div>
</div>


</div>
<div className={style.divIsiForm}>
<div className={style.divInputan}>
    <div>
Nama
    </div>
    <input disabled={true} value={nama}/>
</div>
<div className={style.divInputan}>
    <div>
Alamat
    </div>
    <input disabled={true} value={alamat}/>
</div>
<div className={style.divInputan}>
    <div>
Nomor Handphone
    </div>
    <input disabled={true}   value={nomorHandphone}/>
</div>
<div className={`${style.divInputan} ${style.status}`}>
    <div>
Status
    </div>
    <input value={status}  disabled={true}/>
    
</div>
<div style={{display:member?"flex":"none"}} className={style.divInputan}>
    <div>
Waktu Member
    </div>
    <input type="number" disabled={true}/>
    <select value={waktuMember} onChange={(e)=>{
        WaktuMember(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Member 1 Bulan">
            1 Bulan
        </option>
        <option value="Member 3 Bulan">
            3 Bulan
        </option>
        <option value="Member 6 Bulan">
            6 Bulan
        </option>
       <option value="Member 12 Bulan">
            12 Bulan
        </option>
    
    </select>
</div>
<div style={{display:member?"flex":"none"}} className={style.divInputan}>
    <div>
Expired Member
    </div>
    <input disabled={true}  value={expiredMember}/>
</div>
<div style={{display:member?"flex":"none"}} className={`${style.divInputan} ${style.divPembayaran}`}>
    <div>
Pembayaran
    </div>
    <input type="number" disabled={true}/>
    <select value={pembayaran} onChange={(e)=>{
        setPembayaran(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Cash">
         Cash
        </option>
        <option value="Non Cash">
            Non Cash
        </option>
       
    </select>
</div>
<div style={{display:trainer?"flex":"none"}} className={`${style.divInputan} ${style.gender}`}>
    <div>
Gender
    </div>
    <input type="number" disabled={true}/>
    <select value={gender} onChange={(e)=>{
        setGender(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="cowok">
            cowok
        </option>
        <option value="cewek">
            cewek
        </option>
        
    
    </select>
</div>


</div>
<div className={style.divKirim}>
<div style={{color:keteranganKirim==="Data berhasil terkirim"?"blue":"red"}} className={style.keteranganKirim}>
{keteranganKirim}
</div>
<button onClick={()=>KlikKirim()} className={style.buttonKirim}>
Kirim
</button>

</div>
</div>
    </div>
    </div>
)
}
export default AttendanceGym1MemberPerpanjangan;